<template>
  <Drawer
    width="400"
    :title="`${openedSales ? '编辑' : '新增'}销售项目`"
    v-model="drawerOpened"
  >
    <Modal
      v-model="delSalesModal"
      title="删除销售项目"
      @on-ok="delSales"
    >
      <p>你确定要删除此销售项目吗？</p>
    </Modal>
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem
          label="客户"
          prop="customer"
          style="width: 366px"
        >
          <Select
            v-model="formItem.customer"
            filterable
            :disabled="openedSales ? true : false"
            remote
            style="width: 366px"
            :remote-method="remoteMethod"
            :loading="customerLoading"
            placeholder="请填写客户名字后选择"
          >
            <Option
              v-for="option in customersSimple"
              :value="option._id"
              :key="option._id"
              style="width: 366px"
            >{{ option.name }}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="产品"
          prop="material"
        >
          <Select
            v-model="formItem.material"
            filterable
            clearable
            style="width: 366px"
          >
            <Option
              v-for="option in materialList"
              :value="option._id"
              :key="option._id"
              style="width: 366px; overflow: hidden; white-space: pre-wrap"
            >{{ option.model }} {{ option.name }}</Option>
          </Select>
        </FormItem>

        <FormItem
          label="代称"
          prop="abbr"
        >
          <Input
            type="text"
            v-model="formItem.abbr"
            placeholder="比如惠州建华管桩有限公司的STH-20产品，代称为“建华"
          />
        </FormItem>

        <FormItem
          label="金蝶云物料代码"
          prop="JDItemCode"
        >
          <Input
            type="text"
            v-model="formItem.JDItemCode"
            placeholder="金蝶云物料代码"
          />
        </FormItem>
        <FormItem
          label="合同签署公司"
          prop="company"
        >
          <Select
            v-model="formItem.company"
            filterable
            clearable
          >
            <Option
              v-for="option in companyList"
              :value="option._id"
              :key="option._id"
            >{{ option.name }}</Option>
          </Select>
        </FormItem>

        <FormItem
          label="利润归属公司"
          prop="profitBelongCompany"
        >
          <Select
            v-model="formItem.profitBelongCompany"
            filterable
            clearable
            @on-clear='clearProfitBelongCompany'
          >
            <Option
              v-for="option in companyList"
              :value="option._id"
              :key="option._id"
            >{{ option.name }}</Option>
          </Select>
        </FormItem>

        <FormItem
          label="发货工厂"
          prop="factory"
        >
          <Select
            v-model="formItem.factory"
            filterable
            clearable
          >
            <Option
              v-for="option in factoryList"
              :value="option._id"
              :key="option._id"
            >{{ option.name }}</Option>
          </Select>
        </FormItem>
        
        
        <FormItem
          label="公司内部项目"
          prop="internalShipping"
        >
          <i-switch
            v-model="isInternalShipping"
            @on-change="changeInternalShipping"
          ></i-switch>
        </FormItem>
        <FormItem style="display: flex;">
          <Button
            type="primary"
            @click="handleSubmit('formItem')"
          >保存</Button>
          <Button
            @click="drawerOpened = false"
            style="margin-left: 8px"
          >取消</Button>
        </FormItem>
      </Form>
      
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CreateSalesDrawer",
  data() {
    return {
      drawerOpened: false,
      type: null,
      openedSales: null,
      customerLoading: false,
      isInternalShipping: false,
      formItem: {
        customer: null,
        material: null,
        factory: null,
        abbr: null,
        company: null,
        price: null,
        transCost: null,
        estAging: null,
        noContactPromoFee: null,
        JDItemCode: null,
        profitBelongCompany: null,
      },
      ruleValidate: {
        customer: [
          { required: true, message: "名字为必填项", trigger: "submit" },
        ],
        company: [
          { required: true, message: "公司为必填项", trigger: "submit" },
        ],
        profitBelongCompany: [
          { required: true, message: "公司为必填项", trigger: "submit" },
        ],
        material: [
          { required: true, message: "产品为必填项", trigger: "submit" },
        ],
        factory: [
          { required: true, message: "工厂为必填项", trigger: "submit" },
        ],
      },
      delSalesModal: false,
    };
  },
  computed: {
    ...mapState({
      factoryList: (state) => state.factory.factoryList,
      companyList: (state) => state.company.companyList,
      customersSimple: (state) => state.customer.customersSimple,
      user: (state) => state.auth.currentUser,
      materialList: (state) => state.material.materials,
    }),
  },
  methods: {
    ...mapActions({
      createSales: "sales/createSalesAction",
      updateSales: "sales/updateSalesAction",
      getCustomerSimpleList: "customer/getCustomerSimpleListAction",
    }),
    async remoteMethod(query) {
      if (query !== "" && !this.openedSales) {
        this.customerLoading = true;
        await this.getCustomerSimpleList({ name: query });
        this.customerLoading = false;
      }
    },
    async openDrawer(sales) {
      this.$refs["formItem"].resetFields();
      this.openedSales = sales; // 如果有打开，则为编辑模式
      this.drawerOpened = true;
      if (sales) {
        this.formItem.material = sales.material._id;
        await this.getCustomerSimpleList({ name: sales.customer.name });
        this.formItem.customer = sales.customer._id;
        this.isInternalShipping = sales?.internalShipping;
        this.formItem.factory = sales?.factory._id;
        this.formItem.company = sales?.company._id;
        this.formItem.profitBelongCompany = sales?.profitBelongCompany?._id;
        this.formItem.abbr = sales.abbr;
        this.formItem.JDItemCode = sales.JDItemCode;
      }
    },
    changeInternalShipping(status) {
      this.isInternalShipping = status;
      this.formItem.internalShipping = status;
    },
    clearProfitBelongCompany(e) {
      this.formItem.profitBelongCompany = null
    },
    delSales() {},
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedSales) {
              if (!this.formItem.estAging) {
                delete this.formItem.estAging;
              }
              await this.updateSales({
                id: this.openedSales._id,
                data: this.formItem,
              });
            } else {
              await this.createSales(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
  created() {

  }
};
</script>

<style scoped lang="stylus"></style>
